var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00003 0.359375C4.22733 0.359375 0.359131 4.22758 0.359131 8.99938C0.359013 10.1341 0.582436 11.2578 1.01664 12.3062C1.45084 13.3547 2.08732 14.3073 2.88973 15.1097C3.69213 15.9121 4.64475 16.5486 5.69316 16.9828C6.74158 17.417 7.86526 17.6404 9.00003 17.6403C13.7709 17.6403 17.64 13.7721 17.64 8.99938C17.64 4.22758 13.7709 0.359375 9.00003 0.359375ZM9.80643 3.47878C10.6488 3.47878 10.8963 3.96748 10.8963 4.52638C10.8963 5.22388 10.3383 5.86917 9.38523 5.86917C8.58783 5.86917 8.20803 5.46868 8.23143 4.80538C8.23143 4.24648 8.69853 3.47878 9.80643 3.47878ZM7.64823 14.1744C7.07223 14.1744 6.65193 13.8243 7.05423 12.2898L7.71393 9.56728C7.82823 9.13168 7.84713 8.95708 7.71393 8.95708C7.54203 8.95708 6.79413 9.25768 6.35313 9.55468L6.06603 9.08398C7.46553 7.91488 9.07473 7.22907 9.76323 7.22907C10.3392 7.22907 10.4346 7.90948 10.1475 8.95708L9.39153 11.8191C9.25743 12.3249 9.31503 12.4995 9.44913 12.4995C9.62193 12.4995 10.1871 12.2907 10.7433 11.8524L11.0691 12.2898C9.70743 13.6506 8.22333 14.1744 7.64823 14.1744Z",
    fill: "#7E7E7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyInfo);
export default __webpack_public_path__ + "static/media/grey-info.aecddfb35686ef8550c29d0417ba81a2.svg";
export { ForwardRef as ReactComponent };